<span class="fit-cc-cell">
  <i
    class="k-icon k-i-arrow-45-up-left fit-cc-cell__edit-indicator"
    *ngIf="checkUpdated(item, field, updatedItems, originalData)"
  >
  </i>
</span>
